import React, { Component } from "react";
import {
  Wrapper,
  Card,
  MultiLineInput,
  Copy,
  Bold,
  Scroll,
  Row,
  Button,
  Icon
} from "app/NativeComponents/common";
import { ToggleSwitch } from "app/NativeComponents/snippets";

class CreateSavedReply extends Component {
  constructor(props) {
    super(props);

    const bracket_array = [
      {
        label: "Owner Name",
        slug: "{{owner_name}}"
      },
      {
        label: "Owner First Name",
        slug: "{{owner_firstname}}"
      },
      {
        label: "Owner Last Name",
        slug: "{{owner_lastname}}"
      },
      {
        label: "Property Address Line 1",
        slug: "{{address1}}"
      },
      {
        label: "Property Address Line 2",
        slug: "{{address2}}"
      },

      {
        label: "Property Address City",
        slug: "{{city}}"
      },
      {
        label: "Property Address State",
        slug: "{{state}}"
      },

      {
        label: "Property Address Zip",
        slug: "{{zip}}"
      },
      {
        label: "Full Property Address",
        slug: "{{address}}"
      },

      {
        label: "Your Company Name",
        slug: "{{your_company_name}}"
      },
      {
        label: "Your Full Name",
        slug: "{{your_full_name}}"
      },
      {
        label: "Your First Name",
        slug: "{{your_first_name}}"
      },
      {
        label: "Your Last Name",
        slug: "{{your_last_name}}"
      }
    ];

    this.state = {
      brackets: bracket_array
    };
  }

  render() {
    return (
      <Wrapper>
        <Card>
          <Wrapper
            style={{
              backgroundColor: this.props.colors.background_color,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: this.props.colors.border_color,
              margin: 10,
              borderRadius: 5
            }}
          >
            <Copy
              style={{
                padding: 10,
                paddingBottom: 0
              }}
            >
              <Bold>
                Press an option to insert it into the end of your text:
              </Bold>
            </Copy>

            <Scroll horizontal={true} keyboardShouldPersistTaps={"always"}>
              <Row>
                {this.state.brackets.map((bracket, i) => {
                  return (
                    <Button
                      onPress={() => {
                        this.props.updateField({
                          prop: "response_text",
                          value:
                            this.props.fields.response_text + bracket.slug + " "
                        });
                      }}
                      key={i}
                    >
                      <Card
                        style={{
                          marginRight: 0
                        }}
                      >
                        <Row
                          style={{
                            padding: 10,
                            paddingLeft: 15,
                            paddingRight: 15
                          }}
                        >
                          <Copy style={{ whiteSpace: "nowrap" }}>
                            {bracket.label}
                          </Copy>
                        </Row>
                      </Card>
                    </Button>
                  );
                })}
              </Row>
            </Scroll>
          </Wrapper>

          <MultiLineInput
            ref="saved_reply"
            name="saved_reply"
            autoCapitalize="sentences"
            blurOnSubmit={true}
            returnKeyType="done"
            keyboardType="default"
            placeholder={"Enter your saved reply."}
            label={"Saved Reply"}
            onChange={value =>
              this.props.updateField({ prop: "response_text", value })
            }
            value={this.props.fields.response_text}
            type={"text"}
          />
        </Card>
        <Card>
          <ToggleSwitch
            value={
              parseInt(this.props.fields.starting_response) === 1 ? true : false
            }
            onChange={value => {
              this.props.updateField({
                prop: "starting_response",
                value: value === true ? 1 : 0
              });
            }}
            title={'Use as a "Conversation Starter"?'}
            text={
              'Flipping the slider on will allow this reply to be used as the first text in a conversation. It will be designated as a "Conversation Starter" message and must include the "company name" variable.'
            }
          />
          {this.props.user.team_owner == 1 ||
          this.props.user.team_clearance_level >= 2 ? (
            <Button
              style={{ padding: 25 }}
              onPress={() => {
                this.props.appRedirect({
                  redirect: "editUserInfo"
                });
              }}
            >
              <Row>
                <Copy style={{ marginRight: 5 }}>Update your company name</Copy>
                <Icon size={18} icon={"keyboard-arrow-right"} />
              </Row>
            </Button>
          ) : null}
        </Card>
      </Wrapper>
    );
  }
}

export default CreateSavedReply;
